<template>
  <tg-layout prefixCls="member-reward" :headerHeight="headerHeight">
    <template slot="header">
      <tg-search-tool
        :data="searchData"
        @on-submit="handleSearch"
        :styleObj="{ 'margin-left': '.3em', padding: '0 20px' }"
      >
        <tg-date-search
          ref="dateSearch"
          size="small"
          v-model="dateRange"
          showDateRangePicker
          twoMonthLimit
          isAccountDate
        ></tg-date-search>
        <el-input
          :placeholder="$t('component.form.input.placeholder.member')"
          v-model="searchData.targetName"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>
      <el-row style="padding:5px;">
        <!-- 平台選擇按鈕 -->
        <third-party-search-btn
            style="display:initial;"
            @click.native="showThirdPartyCheckBoxDialog"
        ></third-party-search-btn>
        <third-party-platform
          v-model="third_party"
          @on-change="handleSearchThirdParty"
        ></third-party-platform>
      </el-row>
      <tg-amount-bar
        v-if="showAmount"
        :columns="amountColumns"
        :row="amount"
        :mouseTouch="false"
      ></tg-amount-bar>
    </template>
    <tg-table
      ref="table"
      :columns="columns"
      :proxy="proxy"
      align="center"
      :fit="true"
      showPagination
      @on-loaded="handleLoaded"
      :summary-method="parsePageSummary()"
      showSummary
    >
      <template slot="userfullname" slot-scope="scope">
        <tg-user-full-name
          :row="scope.row"
          :column="scope.column"
        ></tg-user-full-name>
      </template>

      <!-- <template slot="link" slot-scope="scope">
        <a v-if="scope.value > 0" @click.prevent="handleLink(scope)" href>{{
          scope.formated
        }}</a>
        <span v-else>{{ scope.formated }}</span>
      </template> -->

      <template slot="link" slot-scope="scope">
        <span
          :class="{ 'as-link': scope.value > 0 }"
          @click="
            scope.value > 0
              ? handleRewardInfoClick(scope.column, scope.row)
              : null
          "
          >{{ scope.formated }}</span
        >
      </template>

    </tg-table>

    <!-- 獎金info  -->
    <tg-history-reward-info-dialog
      ref="rewardInfo"
      :rewardInfo="rewardInfo"
      @on-click="handleLink()"
    ></tg-history-reward-info-dialog>

    <!-- 平台篩選彈窗 -->
    <third-party-check-box-dialog
      ref="thirdPartyCheckBoxDialog"
      :third_party="third_party"
      @on-click="handleSearchThirdParty"
    ></third-party-check-box-dialog>

  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgAmountBar from "@/components/amount/TgAmountBar";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgHistoryRewardInfoDialog from "@/components/dialog/TgHistoryRewardInfoDialog";
import ThirdPartyCheckBoxDialog from "@/components/dialog/ThirdPartyCheckBoxDialog";
import ThirdPartySearchBtn from "@/components/button/ThirdPartySearchBtn";
import ThirdPartyPlatform from '@/components/tool/ThirdPartyPlatform';

import str from "@/utils/str";
import apis from "@/apis";
import { summary } from "@/utils/table";

import {thirdPartyCheckBoxDialogHandler} from "@/mixins/third_party/dialog";

const api = apis.tg_business.member.reward;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgDateSearch,
    TgAmountBar,
    TgUserFullName,
    TgHistoryRewardInfoDialog,
    ThirdPartyCheckBoxDialog,
    ThirdPartySearchBtn,
    ThirdPartyPlatform
  },
  mixins: [thirdPartyCheckBoxDialogHandler],
  data() {
    return {
      columns: [],
      amountColumns: [],
      amount: {},
      proxy: api.getData,
      searchData: {
        third_party: [],
      },
      third_party:[],
      dateRange: {},
      showAmount: false,
      reward: {},
      rewardInfo: {},
      amountPageData: {}
    };
  },
  created() {
    this.$store.commit("breadcrumb/clear");

    let request = this.request;

    if (this.historyKey) {
      if (!this.$history.exist(this.historyKey)) {
        this.$router.push({ name: this.$route.name });
        return;
      }
      request = this.$history.get(this.historyKey);
      // 需要使用nextTick 不然會被dateSearch元件的mounted蓋掉值
      this.$nextTick(() => {
        this.searchData = { ...request };
        
        this.dateRange = {
          startDate: request.startDate,
          endDate: request.endDate,
        };

        // 處理麵包屑點擊回会员奖金查询的第三方平台同步
        let third_party = [];
        if(request.third_party){
          this.third_party.forEach(element => {
            request.third_party.forEach(one => {
              if(one == element.platform){
                third_party.push(element);
              }
            });
          })
        }
        this.third_party = third_party;
      });
    }
  },
  mounted() {
    api.getColumns({ project: "index" }).then((response) => {
      this.columns = response.data.tableColumns;
      this.amountColumns = response.data.amountColumns;
      this.$refs.table.init(this.request);
    });
  },
  computed: {
    request() {
      return Object.assign({}, this.searchData, this.dateRange);
    },
    parseMaxHeight() {
      return window.innerHeight - 370;
    },
    headerHeight() {
      return this.showAmount ? 180 : 100;
    },
  },
  methods: {
    handleSearch() {
      let historyKey = this.$history.add(this.request);
      this.$router.push({ name: this.$route.name, query: { h: historyKey } });
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        this.amount = response.amount_data;
        this.showAmount = this.amount && response.data.length > 0;
        
        // let amountPageData = response.data.reduce((a, c) => {
        //   Object.keys(a).forEach(k => {
        //     a[k] += parseFloat(c[k]);
        //   });
        //   return a;
        // }, {assign_directpush_reward: 0, assign_team_reward: 0, unassign_team_reward: 0});

        this.amountPageData = response.amountPageData;
      }
    },
    handleLink() {
      let keyData = {
        username: this.rewardInfo.targetName,
        ...this.dateRange,
      };

      let upper_agent = {};

      [20, 40, 60, 70].forEach((g) => {
        let k = "l" + g;
        let col_id = k + "_id";

        if (col_id in this.rewardInfo) {
          upper_agent[k] = this.rewardInfo[col_id];
        }
      });

      let params = {
        ...keyData,
        usernickname: this.rewardInfo["usernickname"],
        title: this.rewardInfo.title,
        reward: this.rewardInfo.reward,
        upper_agent,
        third_party: this.rewardInfo.source_type
      };

      if(this.rewardInfo.source_type == "tg"){
        let historyKey = this.$history.add(params, keyData);

        let pushName = "tg_business.member.reward.games";

        this.$router.push(
          {
            name: pushName,
            query: { h: historyKey },
          },
          () => {},
          () => {}
        );
      }else{
        
        //沙巴直接進入詳細資料頁
        let username = this.rewardInfo["username"];
        
        //沙巴的game_name和game_time留空，不然麵包屑顯示有問題
        let keyData = {
          username,
          game_name: "",
          game_time: "",
        };

        let params = {
            ...this.rewardInfo,
            ...keyData,
        };

        let historyKey = this.$history.add(params, keyData);

        this.$router.push({
            name: "tg_business.member.reward.detail",
            params: { username },
            query: { h: historyKey },
        });

      }
      
    },
    handleSearchThirdParty(value) {
        this.third_party = value;
        this.searchData.third_party = this.third_party.map(r => {
          return r.platform;
        });
        this.$nextTick(() => {
            this.handleSearch();
        });
    },

    handleFilterSearchData(value) {
      this.$nextTick(() => {
        let request = { ...this.request };
        request.third_party = [value];
        this.$refs.table.search(request);
      });
    },
    handleRewardInfoClick(column, row) {
      let title = "";

      if(row.usernickname){
        title = str.format(
          "{0}({1}) - {2}",
          row.username,
          row.usernickname,
          this.$t("column." + column.langKey)
        );
      }else {
        title = str.format(
          "{0} - {1}",
          row.username,
          this.$t("column." + column.langKey)
        );
      }

      this.rewardInfo = {
        ...row,
        status: column.reward.status,
        type: column.reward.type,
        reward: column.reward,
        targetName: row.username,
        ...this.dateRange,
        third_party: this.searchData.third_party,
        title: title,
      };
      this.$refs.rewardInfo.showDialog();
    },
    parsePageSummary() {
      let data = this.amountPageData ? [this.amountPageData] : [];
      
      return () => {
        
        return summary(
          this.columns,
          data,
          this.$t("component.table.summary"),
        );
      };
    },
  },
  watch: {
    $route(value) {
      if (this.$history.exist(value.query.h)) {
        this.searchData = this.$history.get(value.query.h);
      } else {
        if (this.$refs.dateSearch) {
          this.$refs.dateSearch.select("today");
        }
      }

      this.$nextTick(() => {
        this.$refs.table.search(this.request);
      });
    },
    searchData(val) {
      // 需要使用nextTick 不然會被dateSearch元件的mounted蓋掉值
      this.$nextTick(() => {
        if (val.startDate) {
          this.dateRange.startDate = val.startDate;
        }

        if (val.endDate) {
          this.dateRange.endDate = val.endDate;
        }
      });
    },
    showAmount() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
